"use client";

import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import transactionReducer from "./features/transactionSlice";
import customerReducer from "./features/customerSlice";
import shiftReducer from "./features/shiftSlice";
import depositReducer from "./features/depositSlice";
import stockManagementReducer from "./features/stockManagementSlice";
import branchSettingsReducer from "./features/branchSettingsSlice";
import saleReducer from "./features/salesSlice";
import inventoryReducer from "./features/inventorySlice";
import customerCartSlice from "./features/customerCartSlice";
import mapReducer from "./features/mapSlice";

// Create a combined reducer

const rootReducer = combineReducers({
  transaction: transactionReducer,
  customer: customerReducer,
  shift: shiftReducer,
  deposit: depositReducer,
  stockManagement: stockManagementReducer,
  branchSettings: branchSettingsReducer,
  sale: saleReducer,
  inventory: inventoryReducer,
  customerCart: customerCartSlice,
  map: mapReducer,
});

const persistConfig = {
  key: "root",
  storage, //localStorage, defines storage method
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store with the persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializableCheck for redux-persist
    }),
});

export const persistor = persistStore(store);

export default store;
